import React, { useState, useEffect } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { LocaleConsumer } from "containers/locale/LocaleProvider";
import { Row, Col } from "react-flexbox-grid";
import { Typography, Button } from "@material-ui/core";
import { CardContent } from "@material-ui/core";
import ExitCareCircleButton from 'containers/players/ExitCareCircleButton';
import PlayerUsersList from 'containers/users/PlayerUsersList';
import AddIcon from "@material-ui/icons/Add";
import { connect } from 'react-redux';
import PlayerShareModal from 'containers/players/PlayerShareModal';
import { compose } from 'recompose';
import PlayerAddCaregiverModalCareCircle from "../../players/PlayerAddCaregiverModalCareCircle";
import PlayerUsersInstitutionList from "../../users/PlayerUsersInstitutionList";
import InstitutionPlayerUsersList from "../../users/InstitutionPlayerUsersList";
import { getUser, usersSelector } from 'reducers/users';


function PlayerCareCirclePage({
    classes,
    player,
    currentUser,
    institutionCaregivers,
    playerUsers,
    mainUser,
    getUser
}) {
    const [caregiverModalOpen, setCaregiverModalOpen] = useState(false);
    const [institutionUserModalOpen, setInstitutionUserModalOpen] = useState(false);
    const currentUserIsMainUser = player.main_user_id === currentUser.id;
    const mainUserDisplayName = mainUser ? (mainUser.display_name || "").trim() : "";
    const hasMainUserDisplayName = mainUserDisplayName.length > 0;

    useEffect(() => {
        if (player?.main_user_id && !mainUser) {
            getUser(player.main_user_id);
        }
    }, [player?.main_user_id, mainUser, getUser]);

    return (
        <LocaleConsumer>
            {({ getTranslation }) => (
                <CardContent>
                    <Typography gutterBottom>
                        {getTranslation('player_care_circle_summary', player.display_name)}                   
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                        {mainUser
                            ? hasMainUserDisplayName
                                ? `${getTranslation('player_care_circle_admin', mainUserDisplayName)} (${mainUser.email})`
                                : getTranslation('player_care_circle_admin', mainUser.email)
                            : getTranslation('player_care_circle_admin_not_set')
                        }
                    </Typography>
                    {currentUser.is_institution && (
                        <Row>
                            <Col style={{ padding: '0 15px' }}>
                                <div className={classes.profile}>
                                    <Typography variant="h6" style={{ marginBottom: '10px' }}>
                                        {getTranslation('player_care_circle_staff')}
                                    </Typography>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color={'secondary'}
                                        style={{ marginBottom: '10px' }}
                                        onClick={() => setCaregiverModalOpen(true)}>
                                        <AddIcon /> {getTranslation('player_care_circle_staff_add')}
                                    </Button>
                                    <PlayerAddCaregiverModalCareCircle
                                        open={caregiverModalOpen}
                                        onRequestClose={() => setCaregiverModalOpen(false)}
                                        institutionCareGivers={institutionCaregivers}
                                        institutionId={currentUser.id}
                                        playerId={player.id}
                                        playerUsers={playerUsers}
                                    />                          
                                    <div>
                                        <PlayerUsersInstitutionList
                                            institutionId={currentUser.id}
                                            player={player}
                                            playerId={player.id}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col style={{ padding: '0 15px' }}>
                                <div className={classes.profile}>
                                    <Typography variant="h6" style={{ marginBottom: '10px' }}>
                                        {getTranslation('player_care_circle_family')}
                                    </Typography>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color={'secondary'} 
                                        style={{ marginBottom: '10px' }}
                                        onClick={() => setInstitutionUserModalOpen(true)}>
                                        <AddIcon /> {getTranslation('player_care_circle_family_add')}
                                    </Button>
                                    <PlayerShareModal
                                        open={institutionUserModalOpen}
                                        onRequestClose={() => setInstitutionUserModalOpen(false)}
                                        player={player}
                                    />
                                    <div>
                                        <InstitutionPlayerUsersList 
                                            institutionId={currentUser.id}
                                            playerId={player.id} 
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}
                    {!currentUser.is_institution && (
                        <Col style={{ padding: '0 15px' }}>
                            <div className={classes.profile}>
                                <Typography variant="h6" style={{ marginBottom: '10px' }}>
                                    {getTranslation('player_care_circle_family_2')}
                                </Typography>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color={'secondary'} 
                                    style={{ marginBottom: '10px' }}
                                    onClick={() => setInstitutionUserModalOpen(true)}>
                                    <AddIcon /> {getTranslation('player_care_circle_family_add')}
                                </Button>
                                <PlayerShareModal
                                    open={institutionUserModalOpen}
                                    onRequestClose={() => setInstitutionUserModalOpen(false)}
                                    player={player}
                                />
                                <div>
                                    <PlayerUsersList 
                                        playerId={player.id} 
                                    />
                                </div>
                            </div>
                        </Col>
                    )}
                    {!currentUserIsMainUser && (
                        <ExitCareCircleButton 
                            user={currentUser} 
                            player={player} 
                            isCurrentUser={true}                             
                        />
                    )}
                </CardContent>
            )}
        </LocaleConsumer>
    );
}

export default compose(
    connect(
        (state, ownProps) => ({
            currentUser: usersSelector.getCurrentUser(state),
            mainUser:
                ownProps.player.main_user ||
                usersSelector.getUser(state, ownProps.player.main_user_id),
        }),
        (dispatch) => ({
            getUser: (userId) => dispatch(getUser(userId))
        })
    ),
    withStyles({})
)(PlayerCareCirclePage);
